/**
 * Sentra AI — dedicated full-page assistant.
 * Reuses the chat panel in its full-page variant inside the app shell.
 */

import { Layout } from '@/components/common/Layout/Layout';
import { AIChatPanel } from '@/components/ai-assistant';

export function AIAssistantPage() {
  return (
    <Layout fullWidth fill>
      <AIChatPanel variant="page" isOpen onClose={() => {}} />
    </Layout>
  );
}
